<script setup>
import schema from '~/utils/homepage-schema.json';
definePageMeta({middleware:()=>{const client=useUser();if(client.value?.client_id)return navigateTo('/feed',{replace:true});}});
useJsonld(schema);
useSeoMeta({title:'Умный огород — бесплатный онлайн-дневник садовода',titleTemplate:'',description:'Ведите дневник садовода онлайн: посадки, даты, фотографии и заметки по сезонам. Каталог растений, опыт садоводов и бесплатные шаблоны для печати.',ogTitle:'Умный огород — дневник садовода',ogDescription:'Сохраните историю своего сада: растения, даты и заметки. Попробуйте дневник без регистрации.'});
</script>
<template><HomepageLanding /></template>
